import { ApolloProvider } from '@apollo/client/react';
import { BrowserRouter } from 'react-router-dom';
import { apolloClient } from 'api/apolloClient';
import { ToastProvider } from 'components/toast/ToastProvider';
import { AuthProvider } from 'features/auth';
import { AppRoutes } from './AppRoutes';

/**
 * Application root. Provider order matters:
 *   ApolloProvider  -> Apollo client for all data + AuthProvider's cache reset
 *   BrowserRouter   -> routing context for guards and navigation
 *   AuthProvider    -> session state (depends on Apollo)
 *   ToastProvider   -> notifications available to every page
 */
export function App() {
  return (
    <ApolloProvider client={apolloClient}>
      <BrowserRouter>
        <AuthProvider>
          <ToastProvider>
            <AppRoutes />
          </ToastProvider>
        </AuthProvider>
      </BrowserRouter>
    </ApolloProvider>
  );
}

export default App;
